<template>
  <modal
    ref="passwordResetModal"
    template="neutral"
    ref-name="passwordResetModal"
    :icon-enabled="false"
    :close-button-enabled="true"
    class="password-reset-modal"
  >
    <button
      class="close-button btn-transparent"
      @click="closePasswordResetModal"
    >
      <md-icon>clear</md-icon>
    </button>
    <div
      class="password-reset-modal__wrapper"
      :class="{ 'password-reset-modal__wrapper--loading': loading }"
    >
      <spinner
        v-if="loading"
        class="loading"
      />
      <form
        v-else
        class="new-form-component"
      >
        <h3 class="title">Esqueci minha Senha</h3>
        <p
          v-if="isResetSended"
          class="subtitle"
        >
          <strong>Solicitação recebida!</strong>
          <br />
          Se os dados informados estiverem
          <strong>corretos</strong>
          , você receberá um e-mail com uma
          <strong>senha provisória</strong>
          em alguns minutos.
          <br />
          <br />
          <strong>Atenção:</strong>
          Não esqueça de verificar também sua
          <strong>caixa de spam</strong>
          ou
          <strong>lixo eletrônico</strong>
          .
        </p>
        <template v-else>
          <p class="subtitle">Informe o número do laboratório, e‑mail e CPF:</p>
          <div class="input-wrapper">
            <label
              v-if="resetData.labNumber"
              for="labNumber"
            >
              Número do Laboratório
            </label>
            <md-icon class="input-icon left">business</md-icon>
            <input
              id="labNumber"
              v-model.trim="resetData.labNumber"
              type="text"
              placeholder="Número do Laboratório"
              required
            />
          </div>

          <div class="input-wrapper">
            <label
              v-if="resetData.email"
              for="email"
            >
              Email
            </label>
            <md-icon class="input-icon left">mail_outline</md-icon>
            <input
              id="email"
              v-model.trim="resetData.email"
              type="email"
              placeholder="Email"
              required
              @input="validateEmail"
            />
          </div>
          <span
            v-if="!isEmailValid"
            class="err"
          >
            *Digite um e‑mail válido
          </span>

          <div class="input-wrapper">
            <label
              v-if="resetData.cpf"
              for="cpf"
            >
              CPF
            </label>
            <md-icon class="input-icon left">contact_page</md-icon>
            <input
              id="cpf"
              v-model="resetData.cpf"
              v-mask="'###.###.###-##'"
              type="text"
              placeholder="CPF"
              required
              @input="validateCPF"
            />
          </div>
          <span
            v-if="!validateCPF()"
            class="err"
          >
            *Digite um CPF válido
          </span>

          <button
            class="md-button btn btn-primary btn-new"
            :disabled="!isFormComplete"
            @click.prevent="submitReset"
          >
            Resetar Senha
          </button>
        </template>
      </form>
    </div>
  </modal>
</template>

<script>
import userService from '@/api/authentication'
import notify from '@/api/notification'

import { isCPFValid } from '../../../utils/validate-cpf'

import Spinner from '@/components/common/Spinner'

export default {
  name: 'PasswordResetModal',
  components: {
    Spinner,
  },
  data() {
    return {
      loading: false,
      isEmailValid: true,
      resetData: {
        labNumber: '',
        email: '',
        cpf: '',
      },
      isFormComplete: false,
      isResetSended: false,
    }
  },
  watch: {
    resetData: {
      handler() {
        this.validateForm()
      },
      deep: true,
    },
  },
  methods: {
    openPasswordResetModal(data) {
      if (data) {
        this.resetData.labNumber = data.idLab || ''

        if (data.username && data.username.includes('@')) {
          this.resetData.email = data.username || ''
        } else {
          this.resetData.cpf = data.username || ''
        }
      }

      this.$refs.passwordResetModal.open()
    },
    closePasswordResetModal() {
      this.$refs.passwordResetModal.close()
      this.resetData.labNumber = ''
      this.resetData.email = ''
      this.resetData.cpf = ''
      this.isFormComplete = false
      this.isResetSended = false
    },
    validateEmail() {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      this.isEmailValid = regex.test(this.resetData.email)
    },
    validateCPF() {
      return this.resetData.cpf === '' ? true : isCPFValid(this.resetData.cpf)
    },
    validateForm() {
      const fieldsFilled = Object.values(this.resetData).every(value => value !== '')
      this.isFormComplete =
        fieldsFilled && this.isEmailValid && isCPFValid(this.resetData.cpf)
    },
    async submitReset() {
      this.loading = true

      try {
        await this.$recaptchaLoaded()
        const recaptchaToken = await this.$recaptcha('password_reset')

        const data = {
          ...this.resetData,
          recaptchaToken,
        }

        await userService.resetPassword(data)
        this.loading = false
        this.isResetSended = true
      } catch (err) {
        this.loading = false
        this.isResetSended = false
        console.error('Erro ao enviar o reset de senha:', err)

        notify({
          title: 'ERRO: ',
          message: 'Não foi possível enviar o reset de senha!',
        })
      }
    },
  },
}
</script>

<style lang="scss">
.password-reset-modal {
  .md-dialog {
    width: 90%;
    min-width: 400px;
    max-width: 600px;
    padding: 0;

    &-content {
      padding: 0;
    }

    .md-dialog-title {
      display: none;
    }
  }

  &__wrapper {
    padding: 40px;

    &--loading {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .title {
      font-weight: 700;
      font-size: 18px;
      color: #595959;
    }

    .subtitle {
      font-size: 14px;
      color: #363636;
      margin-top: 16px;
    }

    .new-form-component {
      display: flex;
      flex-direction: column;

      .input-wrapper {
        margin-top: 16px;
        position: relative;

        .input-icon {
          position: absolute;
          left: 10px;
          top: 50%;
          transform: translateY(-50%);
        }

        input {
          padding-left: 40px;
        }
      }

      .err {
        font-size: 11px;
        color: red;
      }

      .btn-new {
        margin: 24px auto 0;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      strong {
        color: #7f1a54;
      }
    }
  }
}
</style>
